import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DashedButton from '../DashedButton';

class ExpandableList extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    render: PropTypes.func.isRequired,
    usingTag: PropTypes.string,
    limit: PropTypes.number
  };

  static defaultProps = {
    usingTag: 'ul',
    limit: 5
  };

  state = {
    isExpanded: false
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.limit !== nextProps.limit ||
      this.state.isExpanded !== nextState.isExpanded
    );
  }

  expandList = () => this.setState({ isExpanded: true });

  render() {
    const { usingTag: Tag, items, render, limit } = this.props;

    const { isExpanded } = this.state;

    return (
      <div className='ExpandableList'>
        <Tag className='ExpandableList__list'>
          {items.filter((val, i) => isExpanded || i < limit).map(render)}
        </Tag>
        {!isExpanded && <DashedButton onClick={this.expandList} />}
      </div>
    );
  }
}

export default ExpandableList;
